import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import Card from "../../../../../../atoms/ActiveLearning/Card";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import AssessmentTable from "../../../../../ActiveLearning/AssessmentTable";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import hintImage11 from "../../../../../../assets/images/ActiveLearning/hint/img_11.webp";
import hintImage12 from "../../../../../../assets/images/ActiveLearning/hint/img_12.webp";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);
  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);
  const question3 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 3);
  }, [props.issue?.questions]);
  const question4 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 4);
  }, [props.issue?.questions]);
  const question5 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 5);
  }, [props.issue?.questions]);
  const question6 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 6);
  }, [props.issue?.questions]);
  const question7 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 7);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          ヒントを参考にして、WORK01で考えたアイデアについて調べよう。
        </p>
      </div>
      <img src={hintImage11} alt="調べるためのヒント" />
      <img src={hintImage12} alt="評価ポイント" />
      {question1 && question2 && question3 && question4 && question5 && (
        <AssessmentTable isTeacher />
      )}
      {question6 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question6.title}</p>
          <p className={styles.read}>
            評価を参考にアイデアを選んだり調整したりして、これから実現していく解決のアイデアを考えよう。
          </p>
          <div className={styles.textAreaWrapper}>
            <TextInput />
          </div>
        </div>
      )}
      {question7 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question7.title}</p>
          <p className={styles.read}>
            今回は、「課題」を解決するアイデアを考えた。解決のアイデアを考える過程で気づいたことや考えたことを入力しよう。
          </p>
          <p className={styles.example}>
            例：〇〇のアイデアにするか△△のアイデアにするかで迷っていたけれど、〇〇と△△を組み合わせたらより良いアイデアになると気づいて──
          </p>
          <div className={styles.textAreaWrapper}>
            <TextArea />
          </div>
        </div>
      )}
      <Card label={"TRY"} icon={<IconLive />} title={"グループワーク"}>
        ①同じテーマを選んだメンバーでグループを組もう。
        <br />
        ②自分の考えた解決のアイデアとその理由を発表し合おう。
        <br />
        ③アイデアを具体的にするための話し合いをしよう。
      </Card>
    </div>
  );
};
export default Issue2Material;
